module.exports = __webpack_public_path__ + "img/payments.weekly.baa36432.png";